import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M11.071 4.571a3.071 3.071 0 1 1-6.142 0 3.071 3.071 0 0 1 6.142 0M10.73 8.24a4.571 4.571 0 1 0-5.459 0C2.195 8.797 0 10.27 0 12c0 2.21 3.582 4 8 4s8-1.79 8-4c0-1.73-2.196-3.203-5.27-3.761M14.5 12c0 .23-.226.843-1.514 1.487-1.199.6-2.96 1.013-4.986 1.013-2.027 0-3.787-.414-4.986-1.013C1.726 12.843 1.5 12.23 1.5 12s.226-.843 1.514-1.487C4.213 9.913 5.974 9.5 8 9.5c2.027 0 3.787.414 4.986 1.013C14.274 11.157 14.5 11.77 14.5 12",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h16v16H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }